import { Project } from '../types/project';
import { ConnectionResult } from '../types/connectionResult';
import { ProjectListItemResult } from '../types/projectListItemResult';

export interface ProjectsConnection
  extends ConnectionResult<ProjectListItemResult> {}

export interface GetProjectsResponse {
  getProjects: ProjectsConnection;
}

export interface GetProjectsVariables {
  limit?: number;
  nextToken?: string;
}

export interface GetProjectResponse {
  getProject: Project;
}

export interface GetProjectVariables {
  id: string;
}

export const getProjectsQuery = `
  query GetProjects($limit: Int, $nextToken: String) {
    getProjects(limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        baseListingUrl
        chatEnabled
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getProjectQuery = `
  query GetProject($id: ID!) {
    getProject(id: $id) {
      id
      title
      signatureSecretKey
      jwtSecretKey
      jwtAccessTokenExpiresIn
      jwtRefreshTokenExpiresIn
      baseListingUrl
      chatEnabled
      createdAt
      updatedAt
    }
  }
`;
